export default __webpack_public_path__ + "static/media/51t.06ed4c1d.jpg";